import { CallNumber } from "@ionic-native/call-number";
import { Currency } from "../../schemas/BookLoad/BookLoad.schema";
import { logEvent } from "../../utils/Analytics";
import { EVENT, SCREEN } from "../../utils/constants.analytics";
import { IONICWrapper } from "../../utils/common";
import * as Constants from "../../utils/constants";
import { ICarrierContactInfo } from "../../schemas/App/App.Schema";
import { IPORT_DRAY_CONTACT_DETAILS } from "../../utils/AllInterface";
import { IUserDetails } from "../../schemas/user";
import { IEShipmentInvolvedParty, IShipmentStop } from "../../schemas/getShipment/GetShipment.schema";
import { dayjs } from "../../utils/Date/DateUtil";
import { loadTileButtonVisibility } from "../../utils/sourceTMSAndDivisionFilter";
import { PORTDRAY_CONTACT_INFO_FALLBACK } from "../../utils/constants";

export const getButtonText = (module: string, loadDetails: any, userDetails: any, userDetailsNew:any) => {
  let displayValues = { iconSrc: "", iconClass: "", buttonText: "" };
  if (module === Constants.MODULES.CARRIER_ASSIGNED_MODULE) {     
    displayValues.iconSrc = "assets/icon/add-user-icon.svg";
    displayValues.iconClass = "user-icon";
    displayValues.buttonText = Constants.ASSIGN_DRIVER_CTA_TEXT;      
  } else if (module === Constants.MODULES.DRIVER_ASSIGNED_MODULE) {
    displayValues.iconSrc = "assets/icon/start-trip.svg";
    displayValues.iconClass = "trip-icon";
    displayValues.buttonText = Constants.START_TRIP_TEXT;
  } else if (module === Constants.MODULES.CARRIER_TENDERED_MODULE) {
    if(loadTileButtonVisibility(loadDetails?.sourceTMS,loadDetails?.division,"Accept")){
      displayValues.iconSrc = "assets/icon/accept.svg";
      displayValues.iconClass = "accept-load-icon";
      displayValues.buttonText = Constants.ACCEPT_LOAD_TEXT;
    } else {
      displayValues.buttonText = Constants.CONTACT_US_TEXT}
  } else {
    let buyAllowed =
      loadDetails.rate &&
      loadDetails.rate.totalCharge &&
      loadDetails.buyAllowed;
    displayValues.iconSrc = "";
    displayValues.iconClass = "";
    displayValues.buttonText = buyAllowed
      ? (userDetailsNew && userDetailsNew.memberDetailsResponse &&
        userDetailsNew.memberDetailsResponse.carrierInfo && userDetailsNew.memberDetailsResponse.carrierInfo.carrierActiveIndicator === false? Constants.GET_QUALIFIED_CTA_TEXT :Constants.BOOK_LOAD_CTA_TEXT)
      :
      (userDetailsNew && userDetailsNew.memberDetailsResponse &&
        userDetailsNew.memberDetailsResponse.carrierInfo && userDetailsNew.memberDetailsResponse.carrierInfo.carrierActiveIndicator === false && userDetailsNew.memberDetailsResponse.carrierInfo.source !== "ASL"?
         Constants.GET_QUALIFIED_CTA_TEXT :Constants.CONTACT_FOR_PRICE_CTA_TEXT);
  }
  return displayValues;
};

export const callUs = ({
  sourceSystem,
  loadId,
  carrierId,
  module
}: {
  sourceSystem: string;
  loadId: string;
  carrierId: string;
  module: string;
}) => {
  const lead = getLeadName(module);
    logEvent(EVENT.UE_VIEW_LOAD_CALL_US, {
        screen: SCREEN.LOAD_DETAILS,
        loadId: loadId,
        carrierId: carrierId,
        lead: lead,
      });
};

export const getLeadName = (pageName: string) => {
  let lead = "";
  switch (pageName) {
    case Constants.HOMEMODULES.RECOMMENDED_MODULE: // On view of ad-posting load rate details screen (every time)
      lead = Constants.TAB.RECOMMENDED;
      break;
    case Constants.HOMEMODULES.WATCHED_MODULE:
      lead = Constants.TAB.WATCHED;
      break;
    case Constants.MODULES.SEARCH_RESULTS: // On every time accept is tapped
      lead = Constants.TAB.SEARCHED;
      break;
    case Constants.MODULES.CARRIER_ASSIGNED_MODULE:
      lead = Constants.TAB.CARRIER_ASSIGNED;
      break;
    case Constants.MODULES.DRIVER_ASSIGNED_MODULE:
      lead = Constants.TAB.DRIVER_ASSIGNED;
      break;
    case Constants.MODULES.CARRIER_TENDERED_MODULE:
        lead = Constants.TAB.CARRIER_TENDERED;
        break;
    default:
      lead = Constants.TAB.WATCHED;
  }
  return lead;
};

export const getBuyRequestData = (loadDetails: any, userDetails: IUserDetails) => {
  const data = {
    lhlCharges:
      (loadDetails &&
        loadDetails.rate &&
        loadDetails.rate.lineHaulCharge.charge) ||
      0,
    fsrCharges:
      (loadDetails && loadDetails.rate && loadDetails.rate.fuelCharge.charge) ||
      0,
    carrierId: (userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId) || "",
    userId: (userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.upn) || "",
    sourceSystem: (loadDetails && loadDetails.sourceSystem) || "",
    loadId: loadDetails.loadId,
    amount:
      (loadDetails && loadDetails.rate && loadDetails.rate.totalCharge) || 0,
    binRateId:
      (loadDetails &&
        loadDetails.rate &&
        loadDetails.rate.binRateIdentifier &&
        loadDetails.rate.binRateIdentifier) ||
      "",
    currency: Currency.USD || Currency.CAD,
  };
  return data;
};

export const getCustomer =(shipmentInvolvedParties : IEShipmentInvolvedParty[]) =>
{
  const customer : IEShipmentInvolvedParty | undefined = shipmentInvolvedParties && shipmentInvolvedParties.find(
    (item: any) => item.partyType === "CUSTOMER"
  );
  return customer && customer.partyName || null
}

export const getCurrentDatewithTimeZone =(loadStop : IShipmentStop[] ) =>
{
const loadDetailforTimeZone : IShipmentStop | undefined= loadStop && loadStop.find((load : IShipmentStop) => load.sequenceNo === 1)
const currentTime = new Date().toISOString().slice(0, 16);
return loadDetailforTimeZone && loadDetailforTimeZone.timeZone ?
 dayjs.tz(currentTime.slice(0, 16).replace("T"," "), loadDetailforTimeZone && loadDetailforTimeZone.timeZone).format() :
 dayjs.tz(currentTime.slice(0, 16).replace("T"," "), Constants.TENDER_ACTION_DEFAULT_TIMEZONE).format()
}
